import React, { 
  useCallback, useContext, useMemo, useState 
} from 'react'
import { publishPipelineStatusFetch } from '../../../../utils/api_functions/publishPipelineStatusFetch'
import useClientContext from '../../../contexts/ClientData/ClientData';

const PipelinePublishPackageDetailsContext = React.createContext({
  showPublishDetails: false,
  pipelineChart: null,
  pipelineLocation: null,
  engineUrl: null,
  handleCloseModal: () => {},
  handlePipelinePublishStatusFetch: () => {},
  setShowPublishDetails: () => {},
  setPipelineChart: () => {},
  setPipelineLocation: () => {},
  setEngineUrl: () => {}
})

export const PipelinePublishPackageDetailsProvider = ({ children }) => {
  const [showPublishDetails, setShowPublishDetails] = useState(false)
  const [pipelineChart, setPipelineChart] = useState(null)
  const [pipelineLocation, setPipelineLocation] = useState(null)
  const [engineUrl, setEngineUrl] = useState(null)

  const { isEdgePublishingEnabled } = useClientContext();

  const handlePipelinePublishStatusFetch = useCallback((publishId) => {
    if (!isEdgePublishingEnabled) {
      return;
    }
    setShowPublishDetails(true)

    publishPipelineStatusFetch(publishId).then((res) => {
      setPipelineChart(res?.helm?.chart)
      setPipelineLocation(res?.pipeline_url)
      setEngineUrl(res?.engine_url)
    })
  }, [isEdgePublishingEnabled])

  const handleCloseModal = () => {
    setShowPublishDetails(false)
  }

  const pipelinePublishPackageDetailsContextValue = useMemo(() => ({
    showPublishDetails,
    pipelineChart,
    pipelineLocation,
    engineUrl,
    handleCloseModal,
    handlePipelinePublishStatusFetch,
    setShowPublishDetails,
    setPipelineChart,
    setPipelineLocation,
    setEngineUrl
  }), [engineUrl, handlePipelinePublishStatusFetch, pipelineChart, pipelineLocation, showPublishDetails])

  return (
    <PipelinePublishPackageDetailsContext.Provider value={pipelinePublishPackageDetailsContextValue}>
      {children}
    </PipelinePublishPackageDetailsContext.Provider>
  )
}

export const usePipelinePublishPackageDetails = () => useContext(PipelinePublishPackageDetailsContext);

export default usePipelinePublishPackageDetails;
